function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var filterStyledSystemProps = function filterStyledSystemProps(_ref) {
  var props = _ref.props,
      styledSystemFuncs = _ref.styledSystemFuncs;
  var styledSystemKeys = styledSystemFuncs.map(function (func) {
    return func.propNames;
  }).reduce(function (acc, curr) {
    return acc.concat(curr);
  }, []);
  var nonStyledSystemProps = Object.keys(props).filter(function (key) {
    return !styledSystemKeys.includes(key);
  }).reduce(function (acc, curr) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, curr, props[curr]));
  }, {});
  var styledSystemProps = Object.keys(props).filter(function (key) {
    return styledSystemKeys.includes(key);
  }).reduce(function (acc, curr) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, curr, props[curr]));
  }, {});
  return [nonStyledSystemProps, styledSystemProps];
};